export function convNullDateTime (date) {
  if (date === '0001-01-01T00:00:00Z') {
    return ''
  }
  return date
}

export function convNullDate (date) {
  if (date === '' || date === null) {
    return '0001-01-01'
  }
  return this.$moment(date).format('YYYY-MM-DD')
}

const getText = (m, tz, fmtTZ, fmt) => {
  if (tz) {
    if (tz === true) { // default convert by computer timezone setting of user
      return m.format(fmtTZ)
    } else {
      return m.tz(tz).format(fmtTZ)
    }
  }
  return m.format(fmt)
}

export function getMonthText (str, def) {
  if (str === null || str === '' || typeof str === 'undefined') {
    return def || ''
  }
  return getText(this.$moment(str), false, 'YYYY-MM', 'YYYY-MM')
}

export function getDateText (str, tz, def) {
  if (str === null || str === '' || typeof str === 'undefined') {
    return def || ''
  }
  return getText(this.$moment(str), tz, 'YYYY-MM-DD', 'YYYY-MM-DD')
}

export function getTimeText (str, tz, def) {
  if (str === null || str === '' || typeof str === 'undefined') {
    return def || ''
  }
  return getText(this.$moment(str), tz, 'YYYY-MM-DD HH:mm:ss Z', 'YYYY-MM-DD HH:mm:ss')
}

export function getEndOfMonthText (str, tz, def) {
  if (str === null || str === '' || typeof str === 'undefined') {
    return def || ''
  }
  return getText(this.$moment(str).endOf('month'), tz, 'YYYY-MM-DD HH:mm:ss Z', 'YYYY-MM-DD HH:mm:ss')
}

export function formatLocalTime (d, tz) {
  if (d === null || d === '') {
    return null
  }
  return this.$moment.tz(d, tz).format('YYYY-MM-DDTHH:mm:ss[Z]')
}

export function formatUTCTime (d, tz) {
  if (d === null || d === '') {
    return null
  }
  let t = this.$moment(d).utc().format('YYYY-MM-DD HH:mm:ss') // format to remove timezone
  return this.$moment.tz(t, tz).utc().format()
}

export function formatTime (d, tz) {
  let t = this.$moment(d).format('YYYY-MM-DD HH:mm:ss') // format to remove timezone
  return this.$moment.tz(t, tz).format('YYYY-MM-DDTHH:mm:ssZ')
}

export function validMoment (m, f) {
  return m.isBefore('0001-02-01') ? '-' : m.format(f)
}

export function formatMonth (d) {
  return this.validMoment(this.$moment(d), 'YYYY-MM')
}

export function formatDate (d) {
  return this.validMoment(this.$moment(d), 'YYYY-MM-DD')
}

export function getDateTimeFormat (datetime, isUTC) {
  var m = this.$moment(datetime)
  if (isUTC) {
    m = m.utc()
  }
  return m.format('YYYY-MM-DD HH:mm:ss')
}

export function getBookingTimeFormat (t) {
  return this.$moment.utc(t).local().format('YYYY-MM-DD HH:mm')
}

export function getMonthlyRange (t) {
  let m = this.$moment(t)
  return m.clone().startOf('month').format('YYYY-MM-DD HH:mm:ss') + '~' +
    m.clone().endOf('month').format('YYYY-MM-DD HH:mm:ss')
}

export function getTextByMinutes (min) {
  return (min > 0)
    ? this.$moment.duration(min, 'minutes').humanize()
    : min + ' ' + this.$t('api.minutes')
}

export function getDateRange () {
  if (this.$route.query.date_range) {
    return this.$route.query.date_range.split('~', 2)
  }
  return null
}

export function getDateRangeQuery (range) {
  if (range !== null && range.length === 2) {
    return this.getDateTimeFormat(range[0]) + '~' + this.getDateTimeFormat(range[1])
  }
  return 'all'
}

export function getCheckoutStr (t) {
  return (t === null) ? t : t.slice(0, -3)
}
